import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { CoursesService } from "../services/courses.service";

// TODO: remove? - replaced with courses resolver
@Injectable()
export class CourseDataGuard implements CanActivate {

    constructor(private courses: CoursesService, private router: Router) { }

    // Return false if the user is not logged in
    canActivate() {
      return true;

      // const courseData = this.courses.courses.length;
      // if (courseData != 0) {
      //     return true;
      // } else {
      //     this.router.navigate(['/courses']);
      //     return false;
      // }
    }
}
